import * as React from "react";
import { __, __BETA } from "src/services/theme";

const HTML = (props) => (
    <section className="info">
    
      <header>
        <div className="container">
          <h1>Free visor</h1>
          <p>
            Una scheda dettagliata e ricca di funzioni.<br />
            Informazioni aggiuntive e dettagliate convertono le visite in clienti potenziali con un incremento del 95%.
          </p>
        </div>
      </header>
      
      <div className="features container">
        <h2><span>Caratteristiche</span></h2>
        <p>
        Tutte le caratteristiche del pacchetto <strong>FREE</strong>
        </p>
        <ul className="icons">
          <li>
            <span><span><span className="icon-contact_card" /></span></span>
            <span><strong>Anagrafica</strong></span>
          </li>
          <li>
            <span><span><span className="icon-marker" /></span></span>
            <span><strong>Tasto “Raggiungi Sede”</strong> su mobile</span>
          </li>
          <li>
            <span><span><span className="icon-news" /></span></span>
            <span><strong>Descrizione</strong> scuola</span>
          </li>
          <li>
            <span><span><span className="icon--phone" /></span></span>
            <span><strong>Tasto "Chiama"</strong> su mobile</span>
          </li>
          <li>
            <span><span><span className="icon-mail" /></span></span>
            <span><strong>Assistenza</strong> via email</span>
          </li> 
          <li>
            <span><span><span className="icon-talk" /></span></span>
            <span><strong>Richiesta contatto</strong> nella scheda</span>
          </li>        
        </ul>
      </div>

      {!__BETA &&
      <div className="cta">
        <div className="container">
          <h2>Sottoscrivi PREMIUM</h2>
          <article>
            <span className="price">
              <small>&euro;</small>
              <strong>0,99</strong>
              <span>/giorno</span>
            </span>
            <button className="main2" onClick={() => props.onClick()}><span>Sottoscrivi</span></button>
          </article>
        </div>
      </div>
      }
      
      <div className="faq container">
        <h2><span>Domande frequenti</span></h2>
        <div className="items">
          <article>
            <h4>{__('AcquistiScuolaFree.faq1_title')}</h4>
            <p>{__('AcquistiScuolaFree.faq1_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiScuolaFree.faq2_title')}</h4>
            <p>{__('AcquistiScuolaFree.faq2_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiScuolaFree.faq3_title')}</h4>
            <p>{__('AcquistiScuolaFree.faq3_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiScuolaFree.faq4_title')}</h4>
            <p>{__('AcquistiScuolaFree.faq4_text', 130)}</p>
          </article>
        </div>
      </div>
      
    </section>
);

export default HTML;


// WEBPACK FOOTER //
// ./src/components/ecommerce/AcquistiScuolaInfo/Free.tsx